import FirestoreDocument from "../../../types/FirestoreDocument";
import { email, nullable, preprocess, string } from "../../../types/_types";

import { Vendor } from "../../vendors/types/Vendor";

export const Party = preprocess(
	(party) =>
		party && !party.type ? { ...party, type: "user", name: `${party.firstName} ${party.lastName}` } : party,
	FirestoreDocument.extend({
		img: nullable(string()),
		email: nullable(email()),
		type: string(),
		name: string(),
		vendor: nullable(Vendor.extend({ id: string() })),
	}),
);
